import { ApolloError, useMutation } from "@apollo/client/react";
import {
  GetMyExams,
  GetMyExams_examSyllabusList,
  SaveExamSyllabiForUserInput,
  SaveExamSyllabiForUserVariables,
} from "__generated__/types";
import { useSimpleQuery } from "common/graphql/useSimpleQuery";
import gql from "graphql-tag";

const GET_MY_EXAMS = gql`
  query GetMyExams {
    examSyllabusList(filter: { onlyMine: true }) {
      title
      id
    }
  }
`;

const SIGNUP_FOR_EXAMSYLLABUS = gql`
  mutation SaveExamSyllabiForUser($input: SaveExamSyllabiForUserInput!) {
    saveExamSyllabiForUser(input: $input) {
      examSyllabi {
        title
        id
      }
    }
  }
`;

interface SaveExamSyllabiForUserInputFormValues {
  studyProgrammeId: string;
  examSyllabus: { value: string; label: string }[];
}

export function useMyExamSyllabus(): {
  myExamSyllabi?: GetMyExams_examSyllabusList[];
  saveExamSyllabiForUser: (
    input: SaveExamSyllabiForUserInputFormValues,
  ) => Promise<void>;
  signUpLoading: boolean;
  signUpError: ApolloError | undefined;
  refetch: () => void;
} {
  const { data, refetch } = useSimpleQuery<GetMyExams>(GET_MY_EXAMS);

  const [mutate, { error, loading }] = useMutation<
    SaveExamSyllabiForUserInput,
    SaveExamSyllabiForUserVariables
  >(SIGNUP_FOR_EXAMSYLLABUS);

  const saveExamSyllabiForUser = async (
    input: SaveExamSyllabiForUserInputFormValues,
  ) => {
    await mutate({
      variables: {
        input: {
          studyProgrammeId: input.studyProgrammeId,
          examSyllabiIds: input.examSyllabus.map((e) => e.value),
        },
      },
      refetchQueries: [
        {
          query: GET_MY_EXAMS,
        },
      ],
      awaitRefetchQueries: true,
    });
  };

  return {
    myExamSyllabi: data?.examSyllabusList,
    saveExamSyllabiForUser,
    signUpLoading: loading,
    signUpError: error,
    refetch: refetch,
  };
}
